module.exports = __webpack_public_path__ + "img/manager.67afc1fe.png";